import { Component, OnInit } from '@angular/core';
import { DialogBase } from '@routes/dialogs/dialog.base';
import { finalize } from 'rxjs/operators';
import Utils from '@shared/utils/utils';
import { Constants } from '@shared/constants/constants';
import { CdAction } from '@routes/concealed-damage/concealed-damage-detail/concealed-damage-detail.component';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-concealed-damage-detail-actions',
  templateUrl: './concealed-damage-detail-actions.component.html',
  styleUrls: ['./concealed-damage-detail-actions.component.scss']
})
export class ConcealedDamageDetailActionsComponent extends DialogBase implements OnInit {
  type: any;
  title: any;
  submitBtn: any;
  initInfo: any;
  cdData: any;
  data: any;

  comment: any;
  reason: any;
  reasonOptions: any[] = [];

  ngOnInit(): void {
    if (this.type !== CdAction.REJECT) {
      this.reason = this.type === CdAction.PUMI ?
        this.reasonOptions.find(reason => reason.code === Constants.concealedApprovalReason.PUMI.code)?.code :
        this.reasonOptions.find(reason => reason.code === Constants.concealedApprovalReason.CSD.code)?.code;
      this.reasonOptions = this.type === CdAction.PUMI ?
        this.reasonOptions.filter(reason => reason.code === Constants.concealedApprovalReason.PUMI.code) :
        this.reasonOptions.filter(reason => reason.code === Constants.concealedApprovalReason.CSD.code);

    }
  }

  save() {
    const { ticketNo } = this.initInfo;
    const setData = this.type === CdAction.REJECT ?
      { rejectComment: this.comment, rejectionReason: this.cdData.rejectionReason } :
      { approvalComment: this.comment, ...this.cdData };
    if ([CdAction.PUMI, CdAction.PROCESS].includes(this.type) && !this.reason) {
      return;
    }
    Swal.fire({
      title: `Do you really want to ${ this.type === CdAction.REJECT ? 'reject' : 'approve' }?`,
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      icon: 'question',
    }).then((result) => {
      if (result.isConfirmed) {
        let data = {
          status: this.type === CdAction.REJECT ? Constants.concealedDamageStatus.CSD_REJECT.code : Constants.concealedDamageStatus.CSD_APPROVE.code,
          approvalReason: this.reason,
          ...this.data,
          ...setData,
        };

        this.spinnerService.start();
        this.apiService.concealedDamage.updateConcealedDamage(ticketNo, data)
          .pipe(finalize(() => this.spinnerService.stop()))
          .subscribe(res => {
            if (res) {
              this.onClose.next(true);
              this.bsModalRef.hide();
            }
          }, err => Utils.showError(err));
      } else if (result.isDenied) {
        Swal.fire('Canceled!', '', 'info');
      }
    });
  }
}
